import { cn } from "@/lib/utils"

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center", className)}>
      {/* Text-only Logo */}
      <div className="flex flex-col">
        <span className="font-serif text-2xl leading-tight tracking-wide font-bold">
          <span className="text-black">Ziyareh</span>
        </span>
      </div>
    </div>
  )
} 